module.exports = __webpack_public_path__ + "img/jose-leon-luna-galvez.6c57386b.png";